import React from 'react';
import { Box, useTheme } from '@mui/material';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AppBarComponent from './components/AppBar';
import Hero from './components/Hero';
import Services from './components/Services';
import Projects from './components/Projects';
import Stats from './components/Stats';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ServicesPage from './components/ServicesPage';
import ProjectsPage from './components/ProjectsPage';
import AboutPage from './components/AboutPage';
import ImageCarousel from './components/ImageCarousel';
import { showcase } from './galleries/showcase';

const HomePage = () => {
  return (
    <>
      <Hero />
      {/* <Services /> */}
      <ImageCarousel images={showcase} />
      {/* <Projects /> */}
      {/* <Stats />
      <Contact /> */}
      <Footer />
    </>
  );
};

const App = () => {
  const theme = useTheme();

  return (
    <Router>
      <Box sx={{ 
        flexGrow: 1,
        backgroundColor: theme.palette.background.main,
        minHeight: '100vh'
      }}>
        <AppBarComponent />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/about" element={<AboutPage />} />
        </Routes>
      </Box>
    </Router>
  );
};

export default App;
